import './Loader.scss';
import Lottie from 'lottie-react';
import LottieLoader from './lottieLoader.json';
import { FC } from 'react';

interface propType{
    bottom?: string;
    left?: string;
}
const Loader: FC<propType> = ({bottom, left}) => {
    return(
    <div className='LoaderCtn'>
        {/* <img src={LoadingGif} alt='loader' className='loader'/> */}
        <Lottie 
            animationData={LottieLoader} 
            style={{
                paddingBottom: bottom,
                paddingLeft: left
            }}
            className='lottieStyle'
        />
    </div>
    )
}

export default Loader;
